import { data } from '../../svg/Attributes/data';
import { makeIcon } from '../makeIcon';

export const Attributes = makeIcon(data, 'attributes', 'Attributes');

export default Attributes;
